var ERROR = 500;
var STATUS_CODES = {
  ERROR: ERROR
};
export default STATUS_CODES;